import { useState } from "react";
import { MapPin, Mail, Phone, Globe, Instagram } from "lucide-react";
import { PageHero } from "@/components/Section";
import { InquiryForm } from "@/components/InquiryForm";
import { useSettings } from "@/hooks/useSettings";

export default function Contact() {
  const s = useSettings();
  const [type, setType] = useState("contact");
  return (
    <div data-testid="contact-page">
      <PageHero tag="Let's grow together" title="We're ready" accent="to help you grow." image="/brands/team.jpg">
        Our team is at your service for wholesale pricing, product specifications, samples and distribution opportunities.
      </PageHero>
      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7 sr-card p-7">
          <div className="flex gap-2 mb-6" data-testid="contact-type-tabs">
            {[["contact", "General inquiry"], ["quote", "Wholesale quote"], ["sample", "Sample request"]].map(([v, l]) => (
              <button key={v} onClick={() => setType(v)} data-testid={`contact-type-${v}`} className={`rounded-full px-4 py-2 text-xs font-semibold border transition-colors ${type === v ? "bg-[#0B1F4B] text-white border-[#0B1F4B]" : "border-slate-300 text-slate-600 hover:border-[#1E7CF2]"}`}>{l}</button>
            ))}
          </div>
          <InquiryForm key={type} type={type} testPrefix="contact" submitLabel={type === "quote" ? "Request quote" : type === "sample" ? "Request samples" : "Send message"}
            messagePlaceholder={type === "sample" ? "Which products would you like to sample, and where should we ship them?" : undefined} />
          {type === "quote" && <p className="mt-3 text-xs text-slate-500">Tip: add specific SKUs from the <a href="/catalog" className="text-[#1E7CF2] underline">catalog</a> to your quote list for an itemized request.</p>}
        </div>
        <div className="lg:col-span-5 space-y-5">
          <div className="bg-[#071433] text-white rounded-2xl p-7 grain relative" data-testid="contact-info-card">
            <p className="sr-label text-[#9DC1F5]">{s.company_name}</p>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex gap-3"><MapPin size={18} className="text-[#5AA2FF] shrink-0" /> {s.address}</li>
              <li className="flex gap-3"><Mail size={18} className="text-[#5AA2FF] shrink-0" /> <a href={`mailto:${s.email}`} className="hover:underline">{s.email}</a></li>
              <li className="flex gap-3"><Phone size={18} className="text-[#5AA2FF] shrink-0" /> {s.phone}</li>
              <li className="flex gap-3"><Globe size={18} className="text-[#5AA2FF] shrink-0" /> {s.website}</li>
              <li className="flex gap-3"><Instagram size={18} className="text-[#5AA2FF] shrink-0" /> {s.instagram}</li>
            </ul>
          </div>
          <div className="sr-card-tint p-6 text-sm text-slate-700">
            <p className="font-bold uppercase text-[#0B1F4B] text-xs tracking-wider">Serving 1,000+ pet stores across the U.S.</p>
            <p className="mt-2">ShelfReady AI supports a growing network of retailers and wholesale partners throughout the United States, including Five Below. Featured at Alibaba.com CoCreate 2026 LA.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
